import React, { useEffect, useRef } from "react";
import Logo from "../assets/ops-banner.png";
import moment from "moment";
import { useSelector } from "react-redux";
import JsBarcode from "jsbarcode";

const Row = ({ label, value }) => (
  <div className="flex gap-2 py-1">
    <span className="font-semibold text-gray-700">{label + ":"}</span>
    <span>{value || "-"}</span>
  </div>
);
const Row2 = ({ label, value }) => (
  <div className="flex justify-between p-1 text-xs border border-gray-300">
    <span className="font-semibold text-gray-700">{label}</span>
    <span>{value || "-"}</span>
  </div>
);
const Barcode = ({ value }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (value) {
      JsBarcode(ref.current, value, {
        format: "CODE128",
        width: 1,
        height: 40,
        margin: 0,
        padding: 0,
        displayValue: true,
        fontSize: 10,
      });
    }
  }, [value]);

  return <svg ref={ref}></svg>;
};
const TripSheetPreview = ({ tripSheet, printRef }) => {
  const { user } = useSelector((state) => state.user);

  return (
    <div
      ref={printRef}
      className="p-6 text-sm justify-between bg-white text-black w-full flex flex-col"
      style={{ minHeight: "auto" }}
    >
      <div>
        {/* Header */}
        <div className="flex justify-between items-center border-b pb-3 mb-4 gap-4">
          <div>
            <img
              src={Logo}
              alt="Company Logo"
              className="h-12 object-contain"
            />
          </div>
          <div>
            <Barcode value={tripSheet?.tripSheetNo} />
            {/* <span className="text-xs mt-1">{manifest?.manifestNo}</span> */}
          </div>
        </div>
        {/* Top Info */}
        <div className="grid grid-cols-2 gap-6 mb-5">
          <div>
            <Row
              label="Trip Date"
              value={
                tripSheet?.tripDate
                  ? moment(tripSheet.tripDate).format("DD-MM-YYYY")
                  : "-"
              }
            />
            <Row label="Trip Hire Contact" value={tripSheet?.tripHireContact} />
            <Row label="TripSheet No" value={tripSheet?.tripSheetNo} />
            <Row label="Route Name" value={tripSheet?.routeName} />
            <Row label="Vendor Type" value={tripSheet?.vendorType} />
            <Row label="Vendor Name" value={tripSheet?.vendorName} />
            <Row label="Start KM" value={tripSheet?.startKm} />
          </div>

          <div>
            <Row
              label="Trip Time"
              value={moment(tripSheet?.tripTime, "HH:mm:ss").format(
                "hh:mm:ss A",
              )}
            />
            <Row label="Vehicle Model" value={tripSheet?.vehicleModel} />
            <Row label="Vehicle Number" value={tripSheet?.vehicleNumber} />
            <Row label="Driver Name" value={tripSheet?.driverName} />
            <Row label="Mobile Number" value={tripSheet?.mobileNumber} />
            <Row label="License Number" value={tripSheet?.licenseNumber} />

            <Row label="Ending KM" value={tripSheet?.endKm} />
          </div>
        </div>
        {/* ================= MAIN TABLE ================= */}
        <table className="w-full border border-black border-collapse text-xs mb-4">
          <thead>
            <tr className="bg-gray-200 border border-black">
              {[
                "SL",
                "Manifest No",
                "Start Location",
                "End Location",
                "Total Pkg",
                "Total Weight",
              ].map((h) => (
                <th
                  key={h}
                  className="border border-black px-2 py-1 text-center"
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {tripSheet?.manifests?.map((row, i) => (
              <tr key={i} className="border border-black">
                <td className="border border-black px-2 py-1 text-center">
                  {i + 1}
                </td>
                <td className="border border-black px-2 py-1 text-center">
                  {row?.manifestNo}
                </td>
                <td className="border border-black px-2 py-1 text-center">
                  {row?.startLocation}
                </td>
                <td className="border border-black px-2 py-1 text-center">
                  {row?.endLocation}
                </td>
                <td className="border border-black px-2 py-1 text-center">
                  {row?.totalPkg}
                </td>
                <td className="border border-black px-2 py-1 text-center">
                  {row?.totalWeight}
                </td>
              </tr>
            ))}

            {/* Empty rows for fixed height */}
            {/* {tripSheet?.manifests?.length < 6 &&
            Array.from({
              length: 6 - (tripSheet?.manifests?.length || 0),
            }).map((_, i) => (
              <tr key={`empty-${i}`} className="border border-black h-6">
                {Array(6)
                  .fill("")
                  .map((_, j) => (
                    <td key={j} className="border border-black"></td>
                  ))}
              </tr>
            ))} */}

            {/* Totals (Bottom Right) */}
            {/* <tr className="border border-black font-bold bg-gray-100">
            <td
              colSpan="3"
              className="border border-black px-2 py-2 text-right"
            >
              Total Packages
            </td>
            <td className="border border-black px-2 py-2 text-center">
              {tripSheet?.totalPackages || 0}
            </td>

            <td className="border border-black px-2 py-2 text-right">
              Total Weight
            </td>
            <td className="border border-black px-2 py-2 text-center">
              {tripSheet?.totalWeight || 0} Kg
            </td>
          </tr> */}

            {/* <tr className="border border-black font-bold bg-gray-100">
            <td
              colSpan="5"
              className="border border-black px-2 py-2 text-right"
            >
              Total Expenses
            </td>
            <td className="border border-black px-2 py-2 text-center">
              ₹ {tripSheet?.totalExpenses || 0}
            </td>
          </tr> */}
          </tbody>
        </table>

        <div className="border border-black mb-5 text-xs">
          {/* Row 1 */}
          <div className="grid grid-cols-4 border-b border-black">
            <div className="border-r border-black px-2 py-1 font-semibold bg-gray-100">
              Fuel 1st
            </div>
            <div className="border-r border-black px-2 py-1">
              {tripSheet?.fuel1 || "-"}
            </div>

            <div className="border-r border-black px-2 py-1 font-semibold bg-gray-100">
              Total Packages
            </div>
            <div className="px-2 py-1 font-bold">
              {tripSheet?.manifests?.reduce(
                (sum, s) => sum + Number(s?.totalPkg || 0),
                0,
              ) || 0}
            </div>
          </div>

          {/* Row 2 */}
          <div className="grid grid-cols-4 border-b border-black">
            <div className="border-r border-black px-2 py-1 font-semibold bg-gray-100">
              Fuel 2nd
            </div>
            <div className="border-r border-black px-2 py-1">
              {tripSheet?.fuel2 || "-"}
            </div>

            <div className="border-r border-black px-2 py-1 font-semibold bg-gray-100">
              Total Weight
            </div>
            <div className="px-2 py-1 font-bold">
              {`${
                tripSheet?.manifests?.reduce(
                  (sum, s) => sum + Number(s?.totalWeight || 0),
                  0,
                ) || 0
              } Kg`}
            </div>
          </div>

          {/* Row 3 */}
          <div className="grid grid-cols-4 border-b border-black">
            <div className="border-r border-black px-2 py-1 font-semibold bg-gray-100">
              Total Tolls Paid
            </div>
            <div className="border-r border-black px-2 py-1">
              {tripSheet?.totalTollsPaid || "-"}
            </div>

            <div className="border-r border-black px-2 py-1 font-semibold bg-gray-100">
              Total KM Driven
            </div>
            <div className="px-2 py-1 font-bold">
              {tripSheet?.totalKmDriven || "-"}
            </div>
          </div>

          {/* Row 4 */}
          <div className="grid grid-cols-4 border-b border-black">
            <div className="border-r border-black px-2 py-1 font-semibold bg-gray-100">
              Unloading Charges
            </div>
            <div className="border-r border-black px-2 py-1">
              {tripSheet?.unloadingCharges || "-"}
            </div>

            <div className="border-r border-black px-2 py-1 font-semibold bg-gray-100">
              Total Expenses
            </div>
            <div className="px-2 py-1 font-bold">
              ₹ {tripSheet?.totalExpenses || 0}
            </div>
          </div>

          {/* Row 5 */}
          <div className="grid grid-cols-4 border-b border-black">
            <div className="border-r border-black px-2 py-1 font-semibold bg-gray-100">
              Other Expenses
            </div>
            <div className="border-r border-black px-2 py-1">
              {tripSheet?.otherExpenses || "-"}
            </div>

            <div className="border-r border-black px-2 py-1"></div>
            <div></div>
          </div>

          {/* Row 6 */}
          <div className="grid grid-cols-4">
            <div className="border-r border-black px-2 py-1 font-semibold bg-gray-100">
              Per Kg Expenses
            </div>
            <div className="border-r border-black px-2 py-1">
              {tripSheet?.perKgExpenses || "-"}
            </div>

            <div className="border-r border-black px-2 py-1"></div>
            <div></div>
          </div>
        </div>
      </div>
      {/* ================= FOOTER ================= */}
      <div className="pt-10 footer flex justify-between text-center">
        <div>
          <div className="text-xs">Trip Created By.</div>
          <div className=" border-black mt-1 text-xs mx-auto">
            {user?.name || "-"}
          </div>
        </div>

        <div>
          <div className="text-xs">Trip Approved By.</div>
          <div className=" border-black mt-1  mx-auto"></div>
        </div>
        <div>
          <div className="text-xs">HOD Signature</div>
          <div className=" border-black mt-1  mx-auto"></div>
        </div>
      </div>
    </div>
  );
};

export default TripSheetPreview;
